<div
  class="gh-siv-top-bar workflow-bar no-bottom-border"
  [ngClass]="{
    draft: workflowUi?.actions?.draft,
    'in-review': workflowUi?.actions?.inReview,
    approved: workflowUi?.actions?.approved,
    'needs-reviewers': workflowUi?.actions?.notEnoughReviewers
  }">
  <div class="gh-siv-top-bar-labels">
    <div class="workflow-status-label" [ngSwitch]="workflow?.status">
      <ui-label class="approved" *ngSwitchCase="'approved'" [uiAccent]="true" uiColor="green">
        {{ "approved" | localize }}
      </ui-label>
      <span class="df-aic" *ngSwitchCase="'draft'">
        <ui-label class="draft" [uiAccent]="true" [uiTooltipTrigger]="workflowUi?.owner ? 'hover' : null" [uiTooltipTitle]="workflowDraftTemplate" ui-tooltip uiTooltipPlacement="bottom">
          {{ "draft" | localize }}
        </ui-label>
      </span>
      <span class="df-aic" *ngSwitchCase="'inReview'">
        <ui-label
          class="in-review"
          [uiAccent]="true"
          [uiTooltipTrigger]="workflowUi?.owner ? 'hover' : null"
          [uiTooltipTitle]="workflowInReviewTemplate"
          uiColor="purple"
          ui-tooltip
          uiTooltipPlacement="bottom">
          {{ "in_review" | localize }}
        </ui-label>
      </span>
      <span class="df-aic" *ngSwitchCase="'notEnoughReviewers'">
        <ui-label
          class="needs-reviewers"
          [uiAccent]="true"
          [uiTooltipTrigger]="workflowUi?.owner ? 'hover' : null"
          [uiTooltipTitle]="workflowNeedsReviewersTemplate"
          uiColor="yellow"
          ui-tooltip
          uiTooltipPlacement="bottom">
          {{ "needs_reviewers" | localize }}
        </ui-label>
      </span>
    </div>
    <div class="workflow-reviewers">
      <okr-workflow-avatar-group
        [fromAssigneeIds]="getReviewersIds()"
        [workflow]="workflow"
        [owner]="workflowUi?.owner"
        [max]="5"
        (openEditReviewers)="editReviewers()"
        size="xs"
        assigneeTooltipPlacement="bottom"></okr-workflow-avatar-group>
      <i
        class="edit-reviewers-icon sp-ml-4"
        *ngIf="workflowUi?.owner && workflowUi?.actions?.inReview"
        [uiTooltipTitle]="editReviewersTemplate"
        (click)="editReviewers()"
        ui-icon
        uiType="edit"
        ui-tooltip
        uiTooltipPlacement="bottom">
      </i>
    </div>
  </div>
  <div class="gh-siv-top-bar-actions">
    <button class="workflow-btn" *ngIf="workflowUi?.actions?.draft?.owner" (click)="editReviewers()" ui-button uiShape="round" uiType="primary">
      {{ "send_for_approval" | localize }}
    </button>
    <button class="workflow-btn" *ngIf="workflowUi?.view?.buttons?.approve?.show" (click)="approveOkr()" ui-button uiShape="round" uiType="primary">
      {{ "approve" | localize }}
    </button>
    <button class="workflow-btn" *ngIf="workflowUi?.view?.buttons?.decline?.show" (click)="declineOkr()" ui-button uiShape="round" uiType="default">
      {{ "decline" | localize }}
    </button>
    <button
      class="workflow-btn"
      *ngIf="workflowUi?.view?.buttons?.withdraw?.show"
      [class.needs-reviewers]="workflow?.status === 'notEnoughReviewers'"
      (click)="withdrawOkr()"
      ui-button
      uiShape="round"
      uiType="default">
      {{ "withdraw" | localize }}
    </button>
  </div>
</div>

<ng-template #editReviewersTemplate>
  <div *ngIf="workflow?.status === 'approved'">
    <ui-assignee-name from-assignee-id="reviewer.id"></ui-assignee-name>
    <span>{{ "approved_this_objective" | localize }}</span>
  </div>
  <div *ngIf="workflowUi?.owner && workflow?.status !== 'approved'">{{ "edit_reviewers" | localize }}</div>
</ng-template>

<ng-template #workflowDraftTemplate>
  <div *ngIf="workflowUi?.actions?.draft?.owner && !workflowUi?.actions?.draft?.declined">
    {{ (this.workflow.reviewersNeeded === 1 ? "draft_okr_needs_reviewers" : "draft_okr_needs_two_reviewers") | localize : { amount: this.workflow.reviewersNeeded } }}
  </div>
  <div *ngIf="workflowUi?.actions?.draft?.owner && workflowUi?.actions?.draft?.declined">{{ "okr_in_draft_declined_changes_once_ready_resend" | localize }}</div>
</ng-template>

<ng-template #workflowInReviewTemplate>
  <div *ngIf="workflowUi?.actions?.inReview?.owner || (!workflowUi.actions?.inReview?.owner && !workflowUi.actions?.inReview?.approves && !workflowUi.actions?.notEnoughReviewers?.approves)">
    {{ "this_okr_pending_review_approval" | localize }}
  </div>
</ng-template>

<ng-template #workflowNeedsReviewersTemplate>
  <div *ngIf="workflowUi.actions?.notEnoughReviewers">{{ "this_okr_needs_more_reviewers" | localize }}</div>
</ng-template>
